import React from 'react';
import Snackbar from 'material-ui/Snackbar';
import FlatButton from 'material-ui/FlatButton';
import ClickAwayListener from 'material-ui/internal/ClickAwayListener';

class SnackBarWrapper extends Snackbar {
  render() {
    const {
      onRequestClose,
      onActionTouchTap,
      onActionClick,
      autoHideDuration,
      message: messageProp,
      open: openProp,
      ...other
    } = this.props;

    const { action, message, open } = this.state;

    const {
      muiTheme: {
        baseTheme: {
          fontFamily,
          spacing: { desktopSubheaderHeight },
        },
        snackbar: { backgroundColor, textColor, actionColor },
      },
    } = this.context;

    const actionButton = action && (
      <FlatButton
        label={action}
        onClick={onActionTouchTap}
        style={{
          color: actionColor,
          backgroundColor: 'transparent',
        }}
      />
    );

    const rootStyle = {
      backgroundColor,
      fontFamily,
      display: open ? 'block' : 'none',
      transform: open ? 'translate(0, 0)' : `translate(0, ${desktopSubheaderHeight}px)`,
      width: '400px',
    };

    const messageStyle = {
      color: textColor,
      opacity: open ? 1 : 0,
      transition: open ? 'opacity 500ms linear 100ms' : 'opacity 400ms linear 0ms',
    };

    return (
      <ClickAwayListener onClickAway={open ? this.componentClickAway : null}>
        <div className="error-handler-snackbar" style={rootStyle} {...other}>
          <div className="error-handler-message-box" style={messageStyle}>
            {message}
          </div>
          <div className="error-handler-dismiss-button">{actionButton}</div>
        </div>
      </ClickAwayListener>
    );
  }
}

export default SnackBarWrapper;
